import axios from "axios";
import { BASE_API_URI, BASE_API_V2_URI } from "../constant";
import { logoutHelper } from "../helper";
import dayjs from "dayjs";
import { SESSION_REFRESH_TOKEN } from "./apiPath";

axios.defaults.baseURL = BASE_API_URI;

axios.interceptors.request.use(config => {
  const authToken = localStorage.getItem("accessToken");
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

axios.interceptors.response.use(
  response => {
    if (
      response.status !== 200 ||
      (Object.hasOwn(response.data || {}, "success") && !response.data.success) ||
      (Object.hasOwn(response.data || {}, "statusCode") && response.data.statusCode !== 200)
    ) {
      throw new Error(response.data?.message);
    }
    return response.data;
  },
  error => {
    if (error.response?.status === 401) {
      logoutHelper()
      window.location.href = "/";
      return;
    } else if (error.response?.status === 500) {
      throw new Error("Oops! Something went wrong on our end. Please try again later.");
    }
    throw new Error(error);
  }
);

export const apiRequest = async ({ method, url, req, params }) => {
  axios.defaults.baseURL = BASE_API_URI;
  if (url.startsWith("[V2]")) {
    url = url.replace("[V2]", "");
    axios.defaults.baseURL = BASE_API_V2_URI;
  }
  try {
    if (method === "get") return await axios[method](url, params);
    return await axios[method](url, req, params);
  } catch (error) {
    return { error: error.message };
  }
};
export const getApi = async (url, params) => await apiRequest({ method: "get", url, params });
export const postApi = async (url, req, params) => await apiRequest({ method: "post", url, req, params });
export const putApi = async (url, req, params) => await apiRequest({ method: "put", url, req, params });
export const deleteApi = async (url, req, params) => await apiRequest({ method: "delete", url, req, params });
export const patchApi = async (url, req, params) => await apiRequest({ method: "patch", url, req, params });

// Returns true if successfully refreshed or refresh is not necessary
// Returns false if the token is expired or refresh is unsuccessful
export const refreshToken = async () => {
  const currentToken = localStorage.getItem("accessToken");
  const expirationTime = localStorage.getItem("expiresIn");

  // If we don't have a token, don't attempt to refresh.
  if (!currentToken) return true;

  const expiration = dayjs(expirationTime);
  const now = dayjs();

  if (expiration.isAfter(now)) {
    // Check if we're within 10 minutes of expiring, and if so refresh the token.
    if (expiration.diff(now, "minute") <= 10) {
      try {
        // Directly call api to circumvent normal interceptors
        axios.defaults.baseURL = BASE_API_V2_URI;
        const result = await axios["post"](SESSION_REFRESH_TOKEN, {
          token: currentToken
        });

        if (result?.accessToken) {
          localStorage.setItem("accessToken", result.accessToken);
          localStorage.setItem("expiresIn", result.expiresIn);
        } else {
          return false;
        }
      } catch (err) {
        console.error(err);
        return false;
      }
    }
  } else {
    return false;
  }

  return true;
};